import { useContext } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styledWithTheme from 'foundations-theming/utils';
import { MediaPlaybackControlsContext } from '../context/MediaPlaybackControlsContext';
import { getParsedPlayerStatuses } from '../utils/getParsedPlayerStatuses';
import { MediaElementContext } from '../context/MediaElementContext';
import { useMediaPlayerErrorMessage } from '../hooks/useMediaPlayerErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const PlayerWrapper = styledWithTheme.div(({
  isErrorStatus
}) => {
  return {
    opacity: isErrorStatus ? 0.6 : 1
  };
});
export const InlineMediaPlayerError = ({
  children
}) => {
  const {
    status,
    errorType
  } = useContext(MediaPlaybackControlsContext);
  const {
    recordingUrl
  } = useContext(MediaElementContext);
  const isErrorStatus = getParsedPlayerStatuses(status).isError;
  const tooltipTitle = useMediaPlayerErrorMessage({
    isError: isErrorStatus,
    errorType,
    recordingUrl
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    disabled: !isErrorStatus,
    children: /*#__PURE__*/_jsx(PlayerWrapper, {
      isErrorStatus: isErrorStatus,
      children: children
    })
  });
};